import { DefaultValue, AtomEffect } from "recoil";

export const localStorageEffect: <T>(options: {
  key: string;
  marshal: (t: T) => string | null;
  unmarshal: (value: string) => T;
}) => AtomEffect<T> = ({ key, marshal, unmarshal }) => ({
  trigger,
  setSelf,
  onSet,
}) => {
  const updateFromStorage = () => {
    const value = window.localStorage.getItem(key);
    if (value === null) {
      setSelf(new DefaultValue());
    } else {
      setSelf(unmarshal(value));
    }
  };

  // If initializing from a get request, then check if the value should be set
  // to true
  if (trigger === "get") {
    updateFromStorage();
  }

  // No matter what triggered initialization, update the local storage on updates
  onSet((newValue) => {
    const newStorageValue =
      newValue instanceof DefaultValue ? null : marshal(newValue);
    if (newStorageValue !== null) {
      window.localStorage.setItem(key, newStorageValue);
    } else {
      window.localStorage.removeItem(key);
    }
  });

  const listener: (event: StorageEvent) => void = (event) => {
    if (event.key === key) {
      updateFromStorage();
    }
  };

  window.addEventListener("storage", listener);

  return () => {
    window.removeEventListener("storage", listener);
  };
};
